/* =========================================================
   BUNDLE CONFIGURATOR V2 — sections/bundle-configurator-v2.liquid
   citySelectionState is the one record of which city sits in which
   slot; the picker, the gallery, the plaques and the cart all read it.

   What only Liquid knows is written inline by the section before this
   file runs: window.BUNDLE_T (strings), CF_CUBE_VARIANTS (catalogue),
   CF_PLAQUE (plaque and tool prices and ids), __MONEY_FORMAT__ and
   CF_BCV2 (grid size, base price, image urls). Loaded with `defer`, so
   it runs once the page is parsed and before DOMContentLoaded, the event
   the configurator boots on.
   ========================================================= */
(function () {
  const CFG = window.CF_BCV2 || {};

  /* -----------------------------------------------------------
     Global state
  ----------------------------------------------------------- */
  const basePriceCubeCents = CFG.basePriceCubeCents;

  // Kept with the state rather than in the price function: the cart transform's own
  // percentage lives in a metafield on the transform, and these two must be changed
  // together or the configurator quotes a total the cart does not honour.
  const BUNDLE_PERCENT_OFF = 20;

  /* -----------------------------------------------------------
     THE SMALLEST COLLECTION WE SELL. Enforced on the controls rather than at the door:
     a minus that would take the grid below it is refused and the button greys out, so
     the state can never be under five in the first place.

     NOT a gate on the tabs. They are a scroll-snap carousel — the scroll listener only
     reads back which panel is showing — so disabling "Next" stops the button and not a
     swipe or a trackpad flick. A floor the controls cannot leave holds everywhere.

     The test is on the PRODUCT, not on either side: from 5 x 2 the customer may take the
     length down to 4, because 4 x 2 is eight cities. It is 4 x 1 that is not a collection.
  ----------------------------------------------------------- */
  const BUNDLE_MIN_CITIES = 5;

  /* -----------------------------------------------------------
     The same rounding the collections are priced with, and the same the cart
     transform applies to the merged line: (cities x price), 20% off, then DOWN to a
     number ending in nine. 765 -> 612 -> 609, which is what Metropolis costs.
     Verified against real carts: 9, 12, 18 and 25 cities come out 609, 809, 1219,
     1699, matching Metropolis, Voyager, Skyscraper and Bucket List to the cent.

     Where the nine sits is per currency - window.cfBundleRule, "floor9|1", from
     snippets/cf-bundle-rounding, the theme's one copy of the cart transform's table.
     It must move with bind.py, or this page quotes a total the cart will not
     honour - which is the one failure this whole feature cannot have.
  ----------------------------------------------------------- */
  function cfBundleTotalCents(citiesTotalCents) {
    const target = Math.round(citiesTotalCents * (100 - BUNDLE_PERCENT_OFF) / 100);
    const ruleParts = String(window.cfBundleRule || 'floor9|1').split('|');
    const rule = { mode: ruleParts[0], step: Number(ruleParts[1]) || 1 };
    // citiesTotalCents is already in minor units, and so is step x 100.
    const unit = Math.round(Number(rule.step || 1) * 100);
    if (rule.mode === 'round') return Math.round(target / unit) * unit;
    const nine = 9 * unit;
    const floored = Math.floor((target - nine) / (10 * unit)) * (10 * unit) + nine;
    return floored > 0 ? floored : target;
  }

  // Seeded from Liquid, not from 5 and 1 — see the grid comment at the top of the file.
  // The markup above is already drawn at this size, so nothing has to redraw it.
  let gridLength = CFG.gridLength;
  let gridWidth = CFG.gridWidth;
  // Seeded from the grid too. It was a bare 5 — right only while the grid happened to
  // start 5 x 1 — and the plaque-preview loops below run over it before
  // updateDimensions() has recomputed it, so on first paint a nine-slot grid would have
  // had previews for five of its cities. Exactly the trap citySelectionState documents
  // two lines down.
  let selectedNumberOfCities = CFG.slots;
  let selectedPlaque = 'none';
  // Alignment tool is included automatically only when plaques are selected.
  let selectedTool = 'add';
  let selectedAlignment = 'center';
  // Sized from the grid, not from a constant. It was seeded at 25 while the grid starts 5 x 1, and
  // updateDimensions() — the one place that resizes it — does not run on first paint. So a fresh page
  // carried 25 empty slots behind a five-slot grid, and Auto-Fill, which fills every empty slot it can
  // see, filled all 25.
  let citySelectionState = new Array(gridLength * gridWidth).fill('');

  /* -----------------------------------------------------------
     Money helpers
  ----------------------------------------------------------- */
  function cfFormatMoney(cents) {
    // The shop's money format, exactly as Liquid's | money prints it — see cfMoney in js-variables. This one
    // used to write "609.00 EUR": its own fallback held an amount placeholder that Liquid printed as nothing.
    return window.cfMoney(cents, window.__MONEY_FORMAT__);
  }

  function cfFormatPrice(cents) {
    // The price this page sells - total, struck cities and saving - without ".00" when it has no cents, as
    // price-list prints it. See cfPrice in js-variables.
    return window.cfPrice(cents, window.__MONEY_FORMAT__);
  }

  /* -----------------------------------------------------------
     Custom locations
     - Designs this browser generated in the CUBE custom
       configurator, shaped like a city variant so that every
       function below - the label, the price, the plaque
       auto-fill, the hidden select - works on them unchanged.
  ----------------------------------------------------------- */
  const CUSTOM_PREFIX = CFCities.CUSTOM_PREFIX;

  /*
   * Read at parse time, which is why cf-city-data.js is loaded by a plain
   * <script src> above rather than injected like the picker: this line runs
   * while the page is still parsing, and CFCities has to exist by then.
   *
   * The picker itself no longer needs the list this early - it renders when
   * configure() is called - but the hidden selects and the price still read it,
   * and one read at the top is easier to keep true than three.
   */
  let customDesigns = CFCities.readDesigns();

  const isCustomId = (id) => CFCities.isCustomId(id);

  /*
   * The server garbage-collects previews, and the designs gallery drops an
   * entry whose preview 404s. Do the same here, or the bundle would offer a
   * design that no longer exists and take an order for it. Runs once, off the
   * critical path, and rebuilds the lists only if something actually went.
   */
  async function cfPruneMissingDesigns() {
    const gone = [];
    await Promise.all(customDesigns.map(async (v) => {
      const url = v.design.preview_url;
      if (!url) return;               // nothing to check against
      try {
        const res = await fetch(url, { method: 'HEAD', cache: 'no-store' });
        if (res.status === 404) gone.push(v.design.design_id);
      } catch (_) { }                 // offline or CORS - keep the design
    }));
    if (!gone.length) return;

    const cfg = window.CF_CUBE_CUSTOM || {};
    try {
      const raw = JSON.parse(localStorage.getItem(cfg.bufferKey)) || [];
      localStorage.setItem(cfg.bufferKey, JSON.stringify(raw.filter(d => !gone.includes(d.design_id))));
    } catch (_) { }

    // Anything already sitting in a slot has to come out with it.
    citySelectionState = citySelectionState.map(id => gone.includes(String(id).slice(CUSTOM_PREFIX.length)) ? '' : id);
    customDesigns = CFCities.readDesigns();
    const picker = document.getElementById('bcv2-city-picker');
    if (picker?.renderOptions) { picker.renderOptions(); picker.updateUI(); }
    onSelectionChanged({ source: 'prune' });
  }

  /*
   * The in-stock promise is only true while every slot holds a catalogue city.
   * One design in the bundle and the whole order waits on it being made.
   */
  function cfUpdateShippingNotice() {
    const madeToOrder = citySelectionState.some(isCustomId);
    window.cfShipLine?.set(madeToOrder ? 'custom_cube' : 'stock');
    window.cfShipLine?.basket(cfBasketGrams());
  }

  /*
   * What this Collection would weigh, so the arrival line can say whether UPS
   * Economy applies (snippets/cf-delivery-data). The page knows its cities and
   * its add-ons, so it weighs them rather than inferring from the price: five
   * small cities are 1,750 g and five big ones 2,750 g at the same price, and
   * only one of those is inside the 2 kg band.
   *
   * An empty slot weighs nothing. A custom design has no catalogue row and so
   * no weight, and counts as the heaviest CUBE there is - for an unknown city
   * that is the answer that does not over-promise.
   */
  function cfBasketGrams() {
    const catalogue = window.CF_CUBE_VARIANTS || [];
    let heaviest = 0;
    for (const c of catalogue) heaviest = Math.max(heaviest, Number(c.weightG) || 0);
    let g = 0;
    for (const id of citySelectionState) {
      if (!id) continue;
      if (isCustomId(id)) { g += heaviest; continue; }
      const row = catalogue.find((c) => String(c.id) === String(id));
      g += Number(row?.weightG) || 0;
    }
    /*
     * A plaque goes on every city or on none, and both materials weigh the
     * same. There are no covers here - the collection does not sell them.
     */
    if (selectedPlaque !== 'none') {
      const each = Number(window.CF_PLAQUE?.weightG) || 0;
      g += each * citySelectionState.filter(Boolean).length;
    }
    return g;
  }

  /* Every option a slot can hold, custom designs first. */
  function cfAllOptions() {
    return customDesigns.concat(window.CF_CUBE_VARIANTS);
  }

  /* -----------------------------------------------------------
     City variant lookup helpers
  ----------------------------------------------------------- */
  function getVariantById(id) {
    return cfAllOptions().find(v => String(v.id) === String(id)) || null;
  }

  const isOutOfStock = (variant) => CFCities.isOutOfStock(variant);

  const buildCityLabel = (variant) => CFCities.label(variant, window.BUNDLE_T);

  /* -----------------------------------------------------------
     Multi-select custom element
     - One trigger, one panel with checkboxes
     - Caps selection at selectedNumberOfCities
     - On change, updates citySelectionState (in selection order)
       and the hidden selects, then re-renders gallery + prices.
  ----------------------------------------------------------- */
  /* -----------------------------------------------------------
     The city picker now lives in assets/cf-city-picker.js, because the trio
     configurator needs the same control and customElements.define takes a name
     once per document. It owns no state: everything it reads comes through the
     configure() call in the boot block below.
  ----------------------------------------------------------- */


  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, c => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
    }[c]));
  }

  /* -----------------------------------------------------------
     View Selection modal
  ----------------------------------------------------------- */
  function renderViewSelectionModal() {
    const listEl  = document.querySelector('[data-bcv2-vs-list]');
    const emptyEl = document.querySelector('[data-bcv2-vs-empty]');
    const countEl = document.querySelector('[data-bcv2-vs-counter]');
    if (!listEl) return;

    listEl.innerHTML = '';
    const selectedIds = citySelectionState.filter(v => v !== '');

    if (countEl) {
      countEl.textContent = window.BUNDLE_T.v2_status_selected
        .replace('__C__', selectedIds.length)
        .replace('__M__', selectedNumberOfCities);
    }

    if (selectedIds.length === 0) {
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;

    selectedIds.forEach((id, idx) => {
      const variant = getVariantById(id);
      if (!variant) return;
      const row = document.createElement('div');
      row.className = 'bcv2-vs-row';
      row.innerHTML = `
        <span class="bcv2-vs-index text-xs text-subdued">${idx + 1}</span>
        <span class="bcv2-vs-name">${escapeHtml(buildCityLabel(variant))}</span>
        <button type="button" class="button button--sm bcv2-vs-remove" data-id="${variant.id}" aria-label="${escapeHtml(window.BUNDLE_T.v2_remove)}">
          ${escapeHtml(window.BUNDLE_T.v2_remove)}
        </button>
      `;
      row.querySelector('.bcv2-vs-remove').addEventListener('click', () => {
        const i = citySelectionState.indexOf(String(variant.id));
        if (i === -1) return;
        citySelectionState.splice(i, 1);
        citySelectionState.push('');
        citySelectionState = citySelectionState.slice(0, selectedNumberOfCities);
        while (citySelectionState.length < selectedNumberOfCities) citySelectionState.push('');
        const picker = document.getElementById('bcv2-city-picker');
        if (picker?.updateUI) picker.updateUI();
        renderViewSelectionModal();
        onSelectionChanged({ source: 'view-selection-remove' });
      });
      listEl.appendChild(row);
    });
  }

  /* -----------------------------------------------------------
     Selection-change pipeline (gallery + prices + plaque)
  ----------------------------------------------------------- */
  function onSelectionChanged(/* { source } */) {
    updatePrices();
    cfUpdateShippingNotice();
    cfPlaquesFollow();
    updateGalleryFromState();
    cfKeepSoon();
  }

  // The plaque designer (assets/cf-plaque-designer.js) fills each slot's plaque from its city; when the cities or the
  // grid change it moves the words with their city and fills the new ones, then draws them on the gallery
  // (CFPlaque.syncToGallery, below).
  function cfPlaquesFollow() {
    document.dispatchEvent(new CustomEvent('cf:set-change', { detail: { count: selectedNumberOfCities } }));
    cfUpdateGalleryPlaques();
  }

  function updateGalleryFromState() {
    const totalSlots = gridLength * gridWidth;
    for (let i = 0; i < totalSlots; i++) {
      const slotImg = document.getElementById(`gallery-img-${i}`);
      const parentSlot = slotImg?.closest('.bundle-gallery-slot');
      if (!slotImg || !parentSlot) continue;

      const variantId = citySelectionState[i] || '';
      // Track the variant currently shown in this slot via a data attribute,
      // not slotImg.src (which returns a resolved absolute URL that never
      // matches the raw URL from variant.imgPreview, so every slot would
      // otherwise re-trigger the loading animation on every change).
      const currentVariantId = slotImg.dataset.variantId || '';
      if (currentVariantId === String(variantId)) continue;

      slotImg.dataset.variantId = variantId;

      if (!variantId) {
        slotImg.onload = null;
        slotImg.removeAttribute('src');
        slotImg.classList.remove('loaded');
        parentSlot.classList.remove('is-loading');
        continue;
      }

      const variant = getVariantById(variantId);
      if (variant && variant.imgPreview) {
        parentSlot.classList.add('is-loading');
        slotImg.classList.remove('loaded');
        slotImg.onload = () => {
          parentSlot.classList.remove('is-loading');
          slotImg.classList.add('loaded');

          // The sized composite loaded, so the full one exists and cannot be
          // answered with the hero. Swap it in behind the reader's back, once,
          // and only while this slot still holds the same design.
          const upgrade = variant.imgUpgrade;
          if (!upgrade || slotImg.dataset.upgraded === upgrade) return;
          const probe = new Image();
          probe.onload = () => {
            if (slotImg.dataset.variantId !== String(variantId)) return;
            slotImg.dataset.upgraded = upgrade;
            slotImg.src = upgrade;
          };
          probe.src = upgrade;
        };
        // Walk the candidates on failure - a bigger size the API may not make,
        // then the one it certainly does, then the hero for a design still
        // rendering. A catalogue city has no candidates and behaves exactly as
        // before: one src, no retry.
        const candidates = variant.imgCandidates || [];
        let attempt = 0;
        slotImg.onerror = () => {
          attempt += 1;
          if (attempt < candidates.length) {
            slotImg.src = candidates[attempt];
          } else {
            slotImg.onerror = null;
            parentSlot.classList.remove('is-loading');
          }
        };
        slotImg.src = variant.imgPreview;
      }
    }
  }

  /* -----------------------------------------------------------
     Gallery grid (re)render
  ----------------------------------------------------------- */
  function renderGalleryGrid() {
    const container = document.querySelector('.bundle-gallery-inner');
    if (!container) return;

    // Cap each slot at the 5-column reference size on mobile so the preview
    // never grows beyond what a 5×5 grid would produce. We only constrain
    // COLUMNS; row track sizes are driven by the square slots themselves
    // (aspect-ratio: 1) so rows never stretch beyond the slot height — no
    // gaps between rows when the grid would otherwise have leftover vertical
    // space in the wrapper.
    const isMobileGrid = window.matchMedia('(max-width: 699px)').matches;
    const maxSlot = isMobileGrid ? 'min(18vw, 200px)' : '200px';
    container.style.gridTemplateColumns = `repeat(${gridLength}, minmax(0, ${maxSlot}))`;
    container.style.gridTemplateRows    = '';
    container.innerHTML = '';

    const totalSlots = gridLength * gridWidth;
    const emptyFrameUrl = CFG.emptyFrameUrl;
    const steelImg = CFG.plaqueSteel400;
    const brassImg = CFG.plaqueBrass400;

    for (let i = 0; i < totalSlots; i++) {
      const slot = document.createElement('div');
      slot.className = 'bundle-gallery-slot';
      slot.dataset.slotIndex = i;

      const emptyImg = document.createElement('img');
      emptyImg.src = emptyFrameUrl;
      emptyImg.className = 'bundle-gallery-empty-img';

      const previewImg = document.createElement('img');
      previewImg.id = `gallery-img-${i}`;
      previewImg.className = 'bundle-gallery-preview-img';

      const savedVariantId = citySelectionState[i];
      previewImg.dataset.variantId = savedVariantId || '';
      if (savedVariantId) {
        const variant = getVariantById(savedVariantId);
        if (variant && variant.imgPreview) {
          previewImg.src = variant.imgPreview;
          previewImg.classList.add('loaded');
        }
      }

      const plaqueWrap = document.createElement('div');
      plaqueWrap.className = 'gallery-plaque-wrapper';
      plaqueWrap.id = `gallery-plaque-${i}`;
      plaqueWrap.innerHTML = `
        <img src="${steelImg}" class="gal-plaque-img-steel" style="width:100%; display:none;" loading="lazy" alt="">
        <img src="${brassImg}" class="gal-plaque-img-brass" style="width:100%; display:none;" loading="lazy" alt="">
        <div class="gallery-plaque-text-overlay">
          <span class="gal-head"></span>
          <span class="gal-sub"></span>
        </div>
      `;

      slot.appendChild(emptyImg);
      slot.appendChild(previewImg);
      slot.appendChild(plaqueWrap);
      container.appendChild(slot);
    }

    cfUpdateGalleryPlaques();
    applyPlaqueAlignment();
  }

  /* -----------------------------------------------------------
     Pricing
  ----------------------------------------------------------- */
  function updatePrices() {
    const totalSlots = Number(selectedNumberOfCities || 0);
    const numCitiesSelected = citySelectionState.filter(id => id !== '').length;
    const basePrice = Number(basePriceCubeCents || 0);

    let citiesTotalCents = 0;
    for (let i = 0; i < totalSlots; i++) {
      const selectedId = citySelectionState[i];
      if (selectedId) {
        const variant = getVariantById(selectedId);
        citiesTotalCents += variant ? Number(variant.priceCents) : basePrice;
      } else {
        citiesTotalCents += basePrice;
      }
    }

    const plaqueSteelUnit = Number(window.CF_PLAQUE?.steelCents || 0);
    const plaqueBrassUnit = Number(window.CF_PLAQUE?.brassCents || 0);
    let plaqueUnitSelected = 0;
    if (selectedPlaque === 'steel') plaqueUnitSelected = plaqueSteelUnit;
    if (selectedPlaque === 'brass') plaqueUnitSelected = plaqueBrassUnit;
    const totalPlaqueCost = plaqueUnitSelected * totalSlots;

    // Alignment tool included with plaques; price stays free at 4+ cities (bundle is always 4+)
    const originalToolPrice = Number(window.CF_PLAQUE?.toolCents || 0);
    const shouldIncludeAlignmentTool = selectedPlaque !== 'none' && selectedTool === 'add';
    let toolPriceToCharge = 0;
    if (shouldIncludeAlignmentTool) {
      toolPriceToCharge = numCitiesSelected >= 4 ? 0 : originalToolPrice;
    }

    // The bundle's 20% is a PRICE, not a discount. The cart transform merges these
    // cubes into a single line at 20% off their sum, so the configurator has to show
    // the same number the cart will — nothing is applied later, and no code is typed.
    //
    // On the cubes alone: the engraved plaques and the alignment tool do not carry the
    // _bundle property, are not merged, and keep their price. Same split on both sides.
    //
    // Off the summed line prices, so a clearance city is 20% off ITS price and not off
    // the €85. That is what percentageDecrease does to the merged line, and the two
    // have to agree to the cent.
    const citiesAfterBundleCents = cfBundleTotalCents(citiesTotalCents);

    const grandTotalCents = citiesAfterBundleCents + totalPlaqueCost + toolPriceToCharge;
    // The saving in "You save €426.00 as a Collection": the same cities bought one by one at
    // today's prices — a clearance city at its own, an empty slot at list price — less what they
    // cost as a collection. The collection's alone: the plaques cost the same either way.
    const collectionSavingCents = Math.max(citiesTotalCents - citiesAfterBundleCents, 0);

    // price-list's hooks: the amount into .js-total-price, the saving into .js-total-saving, whose
    // line is shown only when there is one — see price-list.
    document.querySelectorAll('.js-total-price').forEach(el => { el.innerHTML = cfFormatPrice(grandTotalCents); });
    // Klarna's line quotes the collection as configured, plaques included (snippets/klarna-message).
    window.cfKlarnaAmount?.(grandTotalCents);
    document.querySelectorAll('.js-total-saving').forEach(el => {
      const line = el.closest('.price-list__saving') || el;
      el.innerHTML = cfFormatPrice(collectionSavingCents);
      line.hidden = collectionSavingCents <= 0;
    });
    // The singles total struck through above the price, shown only while there is a saving — the same
    // element the non-set configurators drive, so the "Regular price" label survives for screen readers.
    // See price-list: what is struck is the cities one by one, never a compare_at on the set's variant —
    // and the plaques and the tool with them, as the price beside it has them, the way both Set pages
    // strike theirs (2026-10-15). Without them, 12 cities with steel plaques read €929 against €1,020 while
    // the line under it said "You save €211".
    document.querySelectorAll('.js-total-compare').forEach(el => {
      const box = el.closest('compare-at-price') || el;
      if (collectionSavingCents > 0) {
        el.innerHTML = cfFormatPrice(citiesTotalCents + totalPlaqueCost + toolPriceToCharge);
        box.hidden = false;
      } else {
        box.hidden = true;
      }
    });

    cfUpdateGalleryPlaques();
  }

  /* -----------------------------------------------------------
     The plaques (2026-11-01): the plaque designer's window (snippets/plaque-designer, auto) holds each slot's words in
     #plaque-note-N / #plaque-subnote-N; the gallery draws them and the cart sends them. It reaches this page through
     window.CFPlaque: the material, setting it, the slots' cities, and drawing the words on the gallery.
  ----------------------------------------------------------- */
  const plaqueWords = (i) => [
    document.getElementById(`plaque-note-${i}`)?.value.trim() || '',
    document.getElementById(`plaque-subnote-${i}`)?.value.trim() || ''
  ];

  function cfUpdateGalleryPlaques() {
    const isPlaqueActive = selectedPlaque !== 'none';
    const totalSlots = gridLength * gridWidth;

    for (let i = 0; i < totalSlots; i++) {
      const wrap = document.getElementById(`gallery-plaque-${i}`);
      if (!wrap) continue;
      if (!isPlaqueActive) { wrap.classList.remove('is-visible'); continue; }
      wrap.classList.add('is-visible');
      wrap.querySelector('.gal-plaque-img-steel').style.display = (selectedPlaque === 'steel') ? 'block' : 'none';
      wrap.querySelector('.gal-plaque-img-brass').style.display = (selectedPlaque === 'brass') ? 'block' : 'none';
      const [headline, sub] = plaqueWords(i + 1);
      wrap.querySelector('.gal-head').textContent = headline.toUpperCase().replace(/❤️|❤|♥/g, '♡');
      wrap.querySelector('.gal-sub').textContent  = sub.toUpperCase().replace(/❤️|❤|♥/g, '♡');
    }
  }

  function applyPlaqueAlignment() {
    const wrappers = document.querySelectorAll('.gallery-plaque-wrapper');
    let transformValue = 'translateX(-50%)';
    if (selectedAlignment === 'left')  transformValue = 'translateX(-147%)';
    if (selectedAlignment === 'right') transformValue = 'translateX(47%)';
    wrappers.forEach(wrap => { wrap.style.transform = transformValue; });
  }

  // The plaque chosen, from the window (CFPlaque.setMaterial) or a kept Collection (quiet: no tracking event, nothing
  // saved). With a plaque, the alignment switch shows; without, its room stays (theme.css .bcv2-align[data-off]).
  function cfSetPlaque(value, quiet) {
    const before = selectedPlaque;
    selectedPlaque = value;
    // A plaque picked here goes to our tracking as CustomizeProduct (snippets/cf-tracking.liquid).
    if (!quiet && selectedPlaque !== 'none' && selectedPlaque !== before && window.cfCustomize && window.CF_PLAQUE) {
      const steel = selectedPlaque === 'steel';
      window.cfCustomize({
        id: steel ? window.CF_PLAQUE.steelVariantId : window.CF_PLAQUE.brassVariantId,
        cents: steel ? window.CF_PLAQUE.steelCents : window.CF_PLAQUE.brassCents,
        name: 'Engraved Plaque'
      });
    }
    document.querySelector('[data-bcv2-align-block]')?.toggleAttribute('data-off', selectedPlaque === 'none');
    updatePrices();
    if (!quiet) cfKeepSoon();
  }

  function cfSetAlignment(value) {
    selectedAlignment = value;
    const tabs = document.querySelector('[data-bcv2-align-tabs]');
    const index = Array.from(tabs?.querySelectorAll('[data-align]') || []).findIndex(b => b.getAttribute('data-align') === value);
    if (tabs && index > -1 && tabs.selectedIndex !== index) tabs.selectedIndex = index;
    applyPlaqueAlignment();
  }

  // The plaque designer's window (assets/cf-plaque-designer.js) adds, changes or removes the plaques through these: the
  // material ('none' without), setting it, each slot's city - a slot still to fill as null - and the gallery's words.
  window.CFPlaque = {
    material: () => selectedPlaque,
    setMaterial: (mat) => cfSetPlaque(mat === 'steel' || mat === 'brass' ? mat : 'none', false),
    places: () => Array.from({ length: selectedNumberOfCities }, (_, i) => {
      const v = getVariantById(citySelectionState[i]);
      return v ? { ...v, title: buildCityLabel(v) } : null;
    }),
    syncToGallery: () => cfUpdateGalleryPlaques()
  };

  // ONE HEIGHT ON EVERY STEP (Alex, 2026-11-01: "the box size should never change"): the tallest step's, measured - it
  // was a fixed 560px (480px on a phone), mostly empty. Again when the window is resized or the fonts arrive, the
  // steps put back on the one on screen.
  function cfFitSteps() {
    const root = document.querySelector('.bcv2-root');
    const items = Array.from(document.querySelectorAll('.bcv2-root .add-on_item'));
    if (!root || !items.length) return;
    items.forEach(item => { item.style.height = 'auto'; });
    const tallest = Math.max(...items.map(item => item.offsetHeight));
    items.forEach(item => { item.style.height = ''; });
    root.style.setProperty('--tab-container-height', `${Math.ceil(tallest)}px`);
    const NAV = window.__CF_NAV;
    const container = document.querySelector('.bcv2-root .tab-container');
    if (NAV && container) NAV.AX.scrollTo(container, NAV.AX.size(container) * NAV.current, 'auto');
  }

  /* -----------------------------------------------------------
     Auto-fill — the most popular cities first, by popular_rank: the
     order the collection pages' Popular sort uses, maintained on every
     variant. It used to be a hard-coded list of 158 variant ids, three
     of them twice, with 62 cities — every one added since — never on it.
     Regular CUBEs only, as that list was: a clearance city is a last
     piece, not a suggestion. And never a city that cannot be ordered.
  ----------------------------------------------------------- */
  function cfAutoFillGrid() {
    const ranked = (window.CF_CUBE_VARIANTS || [])
      .filter(v => !v.clearance && !isOutOfStock(v))
      .slice()
      .sort((a, b) => (Number(a.rank) || 999) - (Number(b.rank) || 999));
    let next = 0;
    // Bounded by the grid as well as by the array. If the two ever drift apart again the cost is a cart
    // quietly holding cities nobody asked for, so this stops at whichever is smaller.
    const fillTo = Math.min(citySelectionState.length, Number(selectedNumberOfCities) || 0);

    for (let i = 0; i < fillTo; i++) {
      if (citySelectionState[i] !== '') continue;
      while (next < ranked.length && citySelectionState.includes(String(ranked[next].id))) next++;
      if (next >= ranked.length) break;
      citySelectionState[i] = String(ranked[next].id);
      next++;
    }
    const picker = document.getElementById('bcv2-city-picker');
    if (picker?.updateUI) picker.updateUI();
    onSelectionChanged({ source: 'autofill' });
  }

  /* -----------------------------------------------------------
     Dimensions update (grid +/- buttons + slider)
     Per spec: when grid shrinks below current selection count,
     trim from the end.
  ----------------------------------------------------------- */
  function updateDimensions() {
    selectedNumberOfCities = gridLength * gridWidth;

    if (selectedNumberOfCities > citySelectionState.length) {
      while (citySelectionState.length < selectedNumberOfCities) citySelectionState.push('');
    } else if (selectedNumberOfCities < citySelectionState.length) {
      // Compact selected first (selection-order), drop overflow from the end.
      const filled = citySelectionState.filter(v => v !== '');
      const kept   = filled.slice(0, selectedNumberOfCities);
      citySelectionState = kept.concat(new Array(selectedNumberOfCities - kept.length).fill(''));
    }

    document.getElementById('display-length').textContent = gridLength;
    document.getElementById('display-width').textContent  = gridWidth;
    cfSyncDimButtons();
    const totalBadge = document.getElementById('total-cities-badge');
    if (totalBadge) totalBadge.textContent = selectedNumberOfCities;

    const picker = document.getElementById('bcv2-city-picker');
    if (picker?.updateUI) picker.updateUI();

    renderGalleryGrid();
    updatePrices();
    cfPlaquesFollow();
    updateWallFootprint();
  }

  /* A control at its limit should look like it, rather than swallowing the click. Both
     ends, so the ceiling the plus buttons already enforced silently shows too. */
  function cfSyncDimButtons() {
    const set = (dim, action, off) => {
      const btn = document.querySelector(`.bcv2-root .dim-btn[data-dim="${dim}"][data-action="${action}"]`);
      if (btn) btn.disabled = off;
    };
    set('length', 'plus',  gridLength >= 15);
    set('width',  'plus',  gridWidth  >= 10);
    set('length', 'minus', gridLength <= 1 || (gridLength - 1) * gridWidth < BUNDLE_MIN_CITIES);
    set('width',  'minus', gridWidth  <= 1 || gridLength * (gridWidth - 1) < BUNDLE_MIN_CITIES);
  }

  /* The wall's size is snippets/wall-size's (the line under the layout picker, Good to know's Dimensions further
     down, and the spacing slider there, 2026-10-15): this hands it the grid and leaves the sums to assets/wall-size.js. */
  function updateWallFootprint() {
    document.querySelectorAll('[data-wall-size]').forEach((size) => {
      size.dataset.gridLen = gridLength;
      size.dataset.gridWid = gridWidth;
    });
    document.dispatchEvent(new CustomEvent('cf:wall-grid'));
  }

  /* -----------------------------------------------------------
     Add to cart
  ----------------------------------------------------------- */
  async function handleAddToCart(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    const n = selectedNumberOfCities;

    // Every slot must hold something the page can place — the same test the hidden selects made, which accepted a
    // value only if it was one of their options, and those options were exactly cfAllOptions().
    const slotIds = citySelectionState.slice(0, n);
    for (let i = 1; i <= n; i++) {
      if (!getVariantById(slotIds[i - 1])) {
        alert(window.BUNDLE_T.select_city_for_slot.replace('__I__', i));
        return;
      }
    }

    btn.disabled = true;
    btn.textContent = window.BUNDLE_T.adding;

    // One id per configurator run, stamped on every cube of this bundle and nothing
    // else. The cart transform merges lines that share it, so:
    //
    //   * a plaque or the alignment tool is never merged and never discounted;
    //   * a single CUBE the customer adds from anywhere else is not a bundle;
    //   * two bundles configured into one cart stay two lines, not one of ten cubes.
    //
    // A property and not the `bundle_configurator` cart attribute, which is global to
    // the cart: with that, one extra CUBE added afterwards would have been discounted
    // too. The leading underscore keeps it out of the cart and checkout display.
    const bundleId = `b${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;

    // One line per slot. A catalogue city is its own variant; a custom location
    // is a different product carrying the design as properties, which is what
    // CFCities.lineItem knows — shared with the trio product so an order reads
    // the same whichever surface placed it.
    const items = [];
    await CFCities.resolveHeights(slotIds);
    for (let i = 1; i <= n; i++) {
      const slot = slotIds[i - 1];
      const line = CFCities.lineItem(getVariantById(slot) || { id: slot }, { _bundle: bundleId });
      // A slot holding something that cannot be placed — a design whose product
      // has gone, say. Refuse rather than post a NaN id, which /cart/add.js
      // accepts and turns into a line nobody ordered. The button is restored by
      // hand because this returns before the try/finally below.
      if (!line) {
        btn.disabled = false;
        btn.textContent = window.BUNDLE_T.add_to_cart;
        alert(window.BUNDLE_T.error_generic);
        return;
      }
      items.push(line);
    }

    if (selectedPlaque !== 'none') {
      const pId = selectedPlaque === 'steel' ? window.CF_PLAQUE.steelVariantId : window.CF_PLAQUE.brassVariantId;
      for (let i = 1; i <= n; i++) {
        // The designer's words for the slot; a slot it has not filled yet gets its city's name, never a blank plaque.
        const [words, sub] = plaqueWords(i);
        const headline = words || getVariantById(slotIds[i - 1])?.baseCity || '';
        // No Sub-Headline line on the order when it is empty (Alex, 2026-10-16), as on the Set pages.
        const props = { 'Headline': headline };
        if (sub) props['Sub-Headline'] = sub;
        items.push({ id: pId, quantity: 1, properties: props });
      }
    }

    if (selectedPlaque !== 'none' && selectedTool === 'add') {
      items.push({
        id: window.CF_PLAQUE.toolVariantId,
        quantity: 1,
        properties: { 'Bundle Setup': `${gridLength}x${gridWidth}` }
      });
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, attributes: { 'bundle_configurator': 'true' } })
      });
      // An add past a plaque's stock is refused with its own message (assets/cf-addon-stock.js).
      if (!res.ok) { alert((window.CFAddonStock && window.CFAddonStock.takeMessage()) || window.BUNDLE_T.error_generic); return; }
      // In the cart now: the next visit builds a new Collection ("THE COLLECTION IS KEPT").
      cfForgetKept();

      // The drawer, not a trip to /cart. Nothing about the cart transform requires the
      // redirect - it was simply what this wrote.
      //
      // cart:refresh has the drawer, count and dot read the cart again from the server, where
      // the transform has merged the nine cubes into one line at the bundle price. The add
      // response itself echoes the lines as they were sent, at full price, so it is never
      // handed on (2026-10-20: the cart:change that passed a cart here broke in the theme's
      // drawer, which wants the drawer's own sections with it).
      document.dispatchEvent(new Event('cart:refresh'));

      // No drawer where the theme is set to a cart page - then the redirect is right.
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();
      else window.location.href = '/cart';
    } catch (err) { alert(window.BUNDLE_T.error_generic); }
    finally { btn.disabled = false; btn.textContent = window.BUNDLE_T.add_to_cart; }
  }

  /* -----------------------------------------------------------
     Tab navigation — 1:1 port of trio-configurator's scroll-snap logic
  ----------------------------------------------------------- */
  function isMobileViewport() {
    return window.matchMedia('(max-width: 699px)').matches;
  }

  function cfAxis(isDesktop) {
    return {
      size:  isDesktop ? (el) => el.offsetHeight : (el) => el.offsetWidth,
      pos:   isDesktop ? (el) => el.scrollTop    : (el) => el.scrollLeft,
      scrollTo: (el, val, behavior = 'smooth') =>
        isDesktop ? el.scrollTo({ top: val, behavior }) : el.scrollTo({ left: val, behavior })
    };
  }

  function cfIsSafari() {
    const ua = navigator.userAgent;
    return /Safari/.test(ua) && !/Chrome|Chromium|Edg|OPR/.test(ua);
  }

  function initTabNavigation() {
    const isDesktop = !isMobileViewport();
    const AX        = cfAxis(isDesktop);
    const container = document.querySelector('.tab-container');
    if (!container) return;

    // Block wheel/touchmove from scrolling the tab container ITSELF, but
    // allow scrolling inside descendants that opt in via [data-bcv2-scroll]
    // (e.g. the multi-select options list and the tab inner content).
    // Includes boundary check so once the inner element is fully scrolled in
    // that direction, the block resumes (prevents tab-snap from triggering).
    function findScrollableAncestor(e, deltaY) {
      let el = e.target;
      while (el && el !== container) {
        if (el.nodeType === 1 && el.matches && el.matches('[data-bcv2-scroll]')) {
          const canScrollDown = el.scrollTop + el.clientHeight < el.scrollHeight - 1;
          const canScrollUp   = el.scrollTop > 0;
          if (deltaY > 0 && canScrollDown) return el;
          if (deltaY < 0 && canScrollUp)   return el;
          if (deltaY === 0 && (canScrollDown || canScrollUp)) return el;
        }
        el = el.parentNode;
      }
      return null;
    }

    if (isDesktop) {
      container.addEventListener('wheel', (e) => {
        if (e.deltaY === 0) return;
        if (findScrollableAncestor(e, e.deltaY)) return;
        e.preventDefault();
      }, { passive: false });

      let touchStartY = null;
      container.addEventListener('touchstart', (e) => {
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      container.addEventListener('touchmove', (e) => {
        const dy = touchStartY != null ? (touchStartY - e.touches[0].clientY) : 0;
        if (findScrollableAncestor(e, dy)) return;
        e.preventDefault();
      }, { passive: false });
    }

    const panels  = [...container.querySelectorAll('.tab-content')];
    const prevBtn = document.getElementById('horizontal-nav-back');
    const nextBtn = document.getElementById('horizontal-nav-next');
    const mobileSelectCitiesBtn = document.getElementById('bcv2-mobile-select-cities');
    const horNav  = document.querySelector('.horizontal-nav-indicators');
    const verNav  = document.querySelector('.vertical-nav-indicators');

    const NAV = window.__CF_NAV = {
      current: 0,
      total: panels.length,
      AX,
      isDesktop,
      isScrolling: false
    };

    horNav.innerHTML = '';
    verNav.innerHTML = '';
    for (let i = 0; i < NAV.total; i++) {
      const d = document.createElement('span');
      d.className = 'dot' + (i === 0 ? ' active' : '');
      horNav.appendChild(d);

      const vd = document.createElement('span');
      vd.className = 'v-dot' + (i === 0 ? ' active' : '');
      verNav.appendChild(vd);
    }
    const dots  = horNav.querySelectorAll('.dot');
    const vDots = verNav.querySelectorAll('.v-dot');

    function setIndex(i) {
      NAV.current = i;
      dots.forEach((d, ii) => d.classList.toggle('active', ii === i));
      vDots.forEach((d, ii) => d.classList.toggle('active', ii === i));

      const isFirst = i === 0;
      const isLast  = i === NAV.total - 1;

      const buttonWrapper = document.querySelector('.horizontal-nav-button-wrapper');
      const indicators    = document.querySelector('.horizontal-nav-indicators');

      if (buttonWrapper) {
        buttonWrapper.style.display = 'flex';
        requestAnimationFrame(() => buttonWrapper.classList.add('visible'));
      }
      if (indicators) indicators.classList.add('visible');

      prevBtn.disabled = isFirst;
      prevBtn.classList.toggle('disabled', isFirst);
      nextBtn.disabled = isLast;
      nextBtn.classList.toggle('disabled', isLast);
      if (mobileSelectCitiesBtn) mobileSelectCitiesBtn.hidden = !(isFirst && !NAV.isDesktop);
    }
    window.__CF_NAV.setIndex = setIndex;

    function wantToMove(dir) {
      if (dir < 0 && NAV.current === 0) return false;
      return true;
    }

    function scrollToIndex(targetIdx) {
      targetIdx = Math.max(0, Math.min(targetIdx, NAV.total - 1));
      if (NAV.isScrolling) return;
      NAV.isScrolling = true;

      const dist = NAV.AX.size(container) * targetIdx;
      NAV.AX.scrollTo(container, dist, 'smooth');

      const needsFix = cfIsSafari();
      setTimeout(() => {
        if (needsFix) {
          container.classList.add('cf-no-snap');
          NAV.AX.scrollTo(container, dist, 'auto');
          container.offsetHeight; // force reflow
          container.classList.remove('cf-no-snap');
        }
        setIndex(targetIdx);
        NAV.isScrolling = false;
      }, needsFix ? 420 : 520);
    }

    function scrollByPage(dir) {
      if (!wantToMove(dir)) return;
      scrollToIndex(NAV.current + dir);
    }

    prevBtn.addEventListener('click', () => scrollByPage(-1));
    nextBtn.addEventListener('click', () => {
      document.activeElement?.blur?.();
      scrollByPage(+1);
    });
    mobileSelectCitiesBtn?.addEventListener('click', () => {
      document.activeElement?.blur?.();
      scrollToIndex(1);
    });

    container.addEventListener('scroll', () => {
      const idx = Math.round(NAV.AX.pos(container) / NAV.AX.size(container));
      setIndex(Math.min(Math.max(idx, 0), NAV.total - 1));
    }, { passive: true });

    setIndex(0);
  }

  /* -----------------------------------------------------------
     Boot
  ----------------------------------------------------------- */
  /* -----------------------------------------------------------
     ?cities=N — arrive on a grid of that size.

     A collection page offers "build your own" beside its list of twenty-five, and the
     offer is worth nothing if it lands the customer on a grid of five. The count comes
     in; the shape is worked out here, because a bundle is a wall and 25 wants to be
     5 x 5 rather than 25 x 1.

     Closest-to-square that actually divides: the widest divisor no larger than the
     square root becomes the width. 9 -> 3x3, 12 -> 4x3, 18 -> 6x3, 25 -> 5x5. A prime
     has no divisor to find and falls back to a single row, which is what it is.

     Clamped to the same 15 x 10 the plus/minus buttons enforce, so a hand-edited URL
     cannot build a grid the controls could not.
  ----------------------------------------------------------- */
  function cfGridFor(count) {
    const n = Math.max(1, Math.min(150, Math.floor(count)));
    let width = 1;
    for (let w = 1; w * w <= n; w++) {
      if (n % w === 0 && n / w <= 15 && w <= 10) width = w;
    }
    return { length: n / width, width: width };
  }

  function cfApplyUrlPreset() {
    let requested = 0;
    try {
      requested = Number(new URL(window.location.href).searchParams.get('cities')) || 0;
    } catch (err) {
      return false;
    }
    if (!(requested >= BUNDLE_MIN_CITIES)) return false;
    const grid = cfGridFor(requested);
    if (grid.length * grid.width !== Math.floor(requested)) return false;
    // Already the size Liquid drew — a preset arriving as ?variant= lands here — so say
    // no and let the rendered grid stand rather than tearing it down and rebuilding it
    // identically.
    if (grid.length === gridLength && grid.width === gridWidth) return false;
    gridLength = grid.length;
    gridWidth = grid.width;
    return true;
  }

  /* -----------------------------------------------------------
     THE COLLECTION IS KEPT FOR THE VISITOR (2026-10-30, Alex: "same as we do with the individual sets"): its
     grid, the city in each slot, the plaque (steel, brass or none), the two auto-fill choices its words come
     from and the plaque alignment, in this browser's localStorage under cf-collection-config. Leaving the page
     to look at a city, a reload or a day away no longer starts the wall over. As on the CUBE Set
     (cf-set-builder.js, "THE SET IS KEPT"): seven days, then dropped; dropped once it is in the cart, so the
     next visit builds a new one; nothing kept where storage is refused (a private window, a full store).

     Written on what the shopper does - a city picked, removed, cleared or auto-filled (onSelectionChanged),
     the grid resized, a plaque, an alignment or an auto-fill choice picked - and never while the saved one is
     being put back (keepReady), so the restore cannot write over itself.

     Read back as the page opens. A size in the address bar (?cities=N from a collection's "build your own",
     or a ?variant= link) wins over the saved one, and the saved cities fill that many slots, as when the grid
     is made smaller by hand. ?cities= comes off the address bar once read, so a reload or the way back keeps
     the size chosen since. A city the page no longer knows (a design gone from this browser, a variant gone
     from the catalogue) or one out of stock leaves its slot empty: the picker would not let either be chosen.
     A plaque out of stock is not put back, and one that is comes back quietly - no CustomizeProduct, which is
     for a shopper's pick.
  ----------------------------------------------------------- */
  const KEEP_KEY = 'cf-collection-config';
  const KEEP_MS = 7 * 24 * 60 * 60 * 1000;
  let keepReady = false;
  let keepTimer = 0;

  function cfKeep() {
    if (!keepReady) return;
    clearTimeout(keepTimer);
    try {
      localStorage.setItem(KEEP_KEY, JSON.stringify({
        v: 1,
        at: Date.now(),
        length: gridLength,
        width: gridWidth,
        cities: citySelectionState.slice(0, gridLength * gridWidth),
        plaque: selectedPlaque,
        words: Array.from({ length: selectedNumberOfCities }, (_, i) => plaqueWords(i + 1)),
        align: selectedAlignment
      }));
    } catch (_) { }
  }

  function cfKeepSoon() {
    if (!keepReady) return;
    clearTimeout(keepTimer);
    keepTimer = setTimeout(cfKeep, 300);
  }

  function cfForgetKept() {
    clearTimeout(keepTimer);
    try { localStorage.removeItem(KEEP_KEY); } catch (_) { }
  }

  function cfReadKept() {
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(KEEP_KEY)); } catch (_) { return null; }
    if (!saved || saved.v !== 1 || !Array.isArray(saved.cities)) return null;
    if (!(Date.now() - Number(saved.at) < KEEP_MS)) { cfForgetKept(); return null; }
    return saved;
  }

  // Whether the address bar names a size, and ?cities= off it once read (see "THE COLLECTION IS KEPT").
  function cfUrlNamesSize() {
    let url = null;
    try { url = new URL(window.location.href); } catch (_) { return false; }
    const sized = url.searchParams.has('variant') || Number(url.searchParams.get('cities')) >= BUNDLE_MIN_CITIES;
    if (url.searchParams.has('cities')) {
      url.searchParams.delete('cities');
      try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (_) { }
    }
    return sized;
  }

  // The grid and the cities, before the first paint draws them. The plaque and its words follow once their
  // buttons are wired (the boot block below).
  function cfRestoreKept(saved, urlSized) {
    if (!urlSized) {
      const len = Math.round(Number(saved.length));
      const wid = Math.round(Number(saved.width));
      if (len >= 1 && len <= 15 && wid >= 1 && wid <= 10 && len * wid >= BUNDLE_MIN_CITIES) {
        gridLength = len;
        gridWidth = wid;
      }
    }
    citySelectionState = saved.cities.map((id) => {
      const v = id ? getVariantById(id) : null;
      return v && !isOutOfStock(v) ? String(id) : '';
    });
  }


  document.addEventListener('DOMContentLoaded', function () {
    // Sets the numbers only. Liquid drew the grid at the variant's size, and updateDimensions() is what redraws it,
    // so the redraw waits until the first-paint block below — everything between here and there reads the new
    // numbers rather than the old ones.
    cfApplyUrlPreset();
    const kept = cfReadKept();
    const urlSized = cfUrlNamesSize();
    if (kept) cfRestoreKept(kept, urlSized);

    // Dim controls
    document.querySelectorAll('.bcv2-root .dim-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const dimension = btn.getAttribute('data-dim');
        const action = btn.getAttribute('data-action');
        if (dimension === 'length') {
          if (action === 'plus'  && gridLength < 15) gridLength++;
          if (action === 'minus' && gridLength > 1 && (gridLength - 1) * gridWidth >= BUNDLE_MIN_CITIES) gridLength--;
        } else {
          if (action === 'plus'  && gridWidth < 10) gridWidth++;
          if (action === 'minus' && gridWidth > 1 && gridLength * (gridWidth - 1) >= BUNDLE_MIN_CITIES) gridWidth--;
        }
        updateDimensions();
        cfKeepSoon();
      });
    });

    // Where the plaques stand on the picture: the pill switch's tabs.
    document.querySelectorAll('.bcv2-root [data-align]').forEach(btn => {
      btn.addEventListener('click', () => {
        cfSetAlignment(btn.getAttribute('data-align'));
        cfKeepSoon();
      });
    });

    // Words the window writes (a choice for every plaque, a closing that puts them back): on the gallery, and kept.
    let galleryFrame = 0;
    document.addEventListener('input', (e) => {
      if (!e.target.matches?.('[id^="plaque-note-"], [id^="plaque-subnote-"]')) return;
      cancelAnimationFrame(galleryFrame);
      galleryFrame = requestAnimationFrame(cfUpdateGalleryPlaques);
      cfKeepSoon();
    });

    // ATC
    document.getElementById('collections-atc-btn')?.addEventListener('click', handleAddToCart);

    // Clear / Fill
    document.getElementById('clear-cities-btn')?.addEventListener('click', () => {
      if (!confirm(window.BUNDLE_T.clear_confirm)) return;
      citySelectionState = citySelectionState.map(() => '');
      const picker = document.getElementById('bcv2-city-picker');
      if (picker?.updateUI) picker.updateUI();
      document.querySelectorAll('.bundle-gallery-preview-img').forEach(img => {
        img.src = ''; img.classList.remove('loaded');
      });
      onSelectionChanged({ source: 'clear' });
    });

    document.getElementById('fill-cities-btn')?.addEventListener('click', () => {
      cfAutoFillGrid();
    });

    // View Selection modal: populate on every open
    const vsModal = document.getElementById('bcv2-view-selection-modal');
    if (vsModal) {
      vsModal.addEventListener('dialog:before-show', renderViewSelectionModal);
      vsModal.addEventListener('dialog:after-show',  renderViewSelectionModal);
    }
    // Also render once on first click as a safety net in case the
    // dialog component doesn't dispatch the event in this theme version.
    document.getElementById('bcv2-view-selection-btn')?.addEventListener('click', () => {
      renderViewSelectionModal();
    });

    // First paint — start with an EMPTY bundle. User opts into auto-fill via the Fill button.
    //
    // ?cities= and the kept Collection only moved the variables; updateDimensions() is the redraw, and it also
    // fits a kept selection to a grid the address bar sized. Otherwise the grid Liquid drew is the grid — slots
    // and plaque overlays both — so it is not torn down and rebuilt here; it only needs the plaque state and
    // alignment applied, which is what the end of renderGalleryGrid() did to the copy it made.
    if (gridLength !== CFG.gridLength || gridWidth !== CFG.gridWidth || citySelectionState.length !== gridLength * gridWidth) {
      updateDimensions();
    } else {
      cfUpdateGalleryPlaques();
      applyPlaqueAlignment();
    }
    // The kept cities' pictures, prices and plaques - then the kept plaque, its words for each slot over what the
    // window filled in, and its alignment. A material out of stock now is not put back.
    if (kept) {
      onSelectionChanged({ source: 'restore' });
      if (Array.isArray(kept.words)) {
        kept.words.slice(0, selectedNumberOfCities).forEach((pair, i) => {
          if (!Array.isArray(pair) || !citySelectionState[i]) return;
          ['plaque-note-', 'plaque-subnote-'].forEach((prefix, k) => {
            const input = document.getElementById(`${prefix}${i + 1}`);
            if (input && typeof pair[k] === 'string') input.value = pair[k];
          });
        });
      }
      const inStock = document.querySelector(`[data-plaque-material="${kept.plaque}"]:not(.add-on-disabled)`);
      if (inStock && kept.plaque !== 'none') cfSetPlaque(kept.plaque, true);
      if (['left', 'center', 'right'].includes(kept.align)) cfSetAlignment(kept.align);
      document.dispatchEvent(new Event('cf:addon-change'));
    }
    // Unconditionally, because updateDimensions() does not run on a first paint without ?cities=: a grid at the
    // five-city floor has to show its minus as spent before anything is clicked.
    cfSyncDimButtons();
    updatePrices();
    cfUpdateShippingNotice();
    updateWallFootprint();
    initTabNavigation();
    cfFitSteps();
    // The switch on the page's alignment: the theme's tabs start on their first.
    customElements.whenDefined('x-tabs').then(() => cfSetAlignment(selectedAlignment));
    document.fonts?.ready.then(cfFitSteps);
    window.addEventListener('load', cfFitSteps);
    let fitTimer = 0;
    window.addEventListener('resize', () => { clearTimeout(fitTimer); fitTimer = setTimeout(cfFitSteps, 150); });

    /* Hand the picker this section's state. whenDefined rather than a direct
       call: cf-city-picker.js is injected at parse time, and a script inserted
       that way loads async no matter what `defer` says — so the element may not
       have upgraded yet, and `configure` would not exist on it. */
    const picker = document.getElementById('bcv2-city-picker');
    customElements.whenDefined('bcv2-multi-select').then(() => {
      picker?.configure({
        slots: () => selectedNumberOfCities,
        getSelection: () => citySelectionState,
        // Replaces rather than mutates — removing a city rebuilds the array to
        // keep the filled slots contiguous, so the binding itself moves.
        setSelection: (next) => { citySelectionState = next; },
        variants: () => window.CF_CUBE_VARIANTS || [],
        designs: () => customDesigns,
        label: buildCityLabel,
        // As on the CUBE Set (set-product.liquid): a city's name with its area under it, and the
        // bestseller and new filters under the search (cf-city-picker-filters).
        optionLines: (v) => [buildCityLabel({ ...v, variantCity: '' }), v.variantCity || ''],
        filters: { bestseller: (v) => v.isFavorite === true, new: (v) => v.isNew === true },
        outOfStock: isOutOfStock,
        t: {
          max_reached: window.BUNDLE_T.v2_max_reached,
          status_selected: window.BUNDLE_T.v2_status_selected,
          group_custom: window.BUNDLE_T.group_custom,
          group_collection: window.BUNDLE_T.group_collection
        },
        onChange: onSelectionChanged
      });
    });
    // A design made in the other tab (cf-city-data.js): the list has it, and the place that sent the visitor there
    // gets it (cf-city-picker.js, awaitDesign).
    document.addEventListener('cf:designs-change', () => {
      customDesigns = CFCities.readDesigns();
      picker?.refresh?.();
    });
    // Put back - from here on the shopper's changes are kept.
    keepReady = true;
    if (customDesigns.length) cfPruneMissingDesigns();
  });
})();
